angular.module('stack.common.api.ApiController', [
  'global',
  'stack.common.api.ApiService'
])

/**
 * The ApiController manages view logic rendered
 * to the apis.html template.
 *
 * @class ApiController
 * @constructor
 * @module stack.common.apis
 */
.controller('ApiController', [
  '$scope',
  'GLOBAL',
  'ApiService',
  'ValidationService',
  function ($scope, GLOBAL, ApiService, ValidationService) {
    'use strict';

    /**
     * $scope reference for all apis in array
     * @property apis
     * @type {Array<Object>}
     */
    $scope.apis = ApiService.apis;

    /**
     * $scope reference for the currently selected selectedApi
     * @property selectedApi
     * @type {Object}
     */
    $scope.selectedApi = null;

    /**
     * $scope reference for the currently selected selectedEndpoint
     * @property selectedEndpoint
     * @type {Object}
     */
    $scope.selectedEndpoint = null;

    /**
     * $scope reference for the data returned from an API call
     * @property testReturn
     * @type {Object}
     */
    $scope.testReturn = '';

    /**
     * $scope reference for the GLOBAL
     * @property GLOBAL
     * @type {string}
     */
    $scope.GLOBAL = GLOBAL;

    /**
     * $scope reference for the success of a test
     * @property testSuccess
     * @type {boolean}
     */
    $scope.testSuccess = false;

    /**
     * $scope reference for the success of validation
     * @property validationSuccess
     * @type {boolean}
     */
    $scope.validationSuccess = false;

    /**
     * $scope reference to hold any validation errors
     *
     * @property validationErrors
     * @type {Array<Object>}
     */
    $scope.validationErrors = [];


    /**
     * Selects items from the API menu
     *
     * @param {Object} group - Selected group object
     * @param {Object} [api] - Selected api object
     */
    $scope.selectApi = function selectApi(group, api) {
      $scope.resetTest();
      if (api && group) {
        $scope.selectedEndpoint = group;
        $scope.selectedApi = api;
      } else if (group) {
        $scope.selectedEndpoint = group;
        $scope.selectedApi = null;
      }
    };

    /**
     * Resets the test status
     */
    $scope.resetTest = function resetTest() {
      $scope.testReturn = '';
      $scope.testSuccess = false;
      $scope.validationSuccess = false;
      $scope.validationErrors = [];
    };

    /**
     * Executes a provided api call
     *
     * @param {Object} api - API object to execute
     */
    $scope.testAPI = function testAPI(api) {
      ApiService
        .execute(api, api.sendData.data)
        .then(function (response) {
          $scope.testSuccess = true;

          // clean up response JSON
          delete response.result;
          delete response.$promise;
          delete response.$resolved;

          validateAPICall(api, response);

          $scope.testReturn = JSON.stringify(response, undefined, 4);
          return $scope.testReturn;
        })
        .catch(function (response) {
          $scope.testSuccess = false;
          $scope.testReturn = response;
        });
    };

    /**
     * JHelper method to setup and run JSON
     * validation through the ValidationService
     * and hook results to current $scope
     *
     * @param {Object} api - The API the call is run from
     * @param {Object} response - The response fropm the API call
     * @private
     */
    function validateAPICall(api, response) {
      var schema = api.defaultSchema;
      var result;

      // set schema that will be used
      if (api.sendData.data.id) {
        schema += '-id';
      }
      if (api.sendData.data.filter) {
        schema = schema + '-' + api.sendData.data.filter;
      }

      // lint data
      result = ValidationService.lintData(response);

      // if linting is successful, then check against schema
      if (result.valid) {
        result = ValidationService.testAgainstSchema(response, schema);
      }

      $scope.validationSuccess = result.valid;
      $scope.validationErrors = result.errors;
    }
  }
]);
